import { render } from "./user-single.vue?vue&type=template&id=512993b3&scoped=true"
import script from "./user-single.vue?vue&type=script&lang=js"
export * from "./user-single.vue?vue&type=script&lang=js"

import "./user-single.vue?vue&type=style&index=0&id=512993b3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512993b3"]])

export default __exports__